/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

const getMessage = state => state.message;
const getJobOfferForm = state => state.jobOfferForm;
const getConstants = state => state.bootstrap.constants;

export const makeCreateJobOfferForm = () =>
  createSelector(
    [getMessage, getJobOfferForm, getConstants],
    (message, jobOfferForm, constants) => {
      const fieldsets = jobOfferForm.fieldsets.map(({ legend, inputs }) => ({
        legend,
        inputs: inputs
          .map(
            input =>
              input.name === 'currency'
                ? { ...input, options: constants.compensation_currency }
                : input
          )
          .map(
            input =>
              message.contract &&
              typeof message.contract[input.name] !== 'undefined'
                ? { ...input, value: message.contract[input.name] }
                : input
          ),
      }));

      return {
        ...jobOfferForm,
        fieldsets: fieldsets.map(({ legend, inputs }) => ({
          legend,
          inputs,
        })),
      };
    }
  );
